import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { config } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';

config.autoAddCss = false;

class Sort extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortDirection: props.sortData.direction,
    };

    this.onSortChange = this.onSortChange.bind(this);
  }


  onSortChange() {
    let newDirection = 'desc';
    if (!this.state.sortDirection || this.state.sortDirection === 'asc') {
      this.setState({ sortDirection: 'desc' });
    } else {
      this.setState({ sortDirection: 'asc' });
      newDirection = 'asc';
    }
    this.props.onSortChange(this.props.sortData.sortBy, newDirection);
  }


  render() {
    return (
      <button
        onClick={this.onSortChange}
      >
        <span className="sort-direction-label">{ this.props.sortData.label }</span>
        <FA
          icon={this.state.sortDirection === 'asc' ? faChevronUp : faChevronDown}
          className="sort-direction-icon"
          fixedWidth
        />
      </button>
    );
  }
}

Sort.propTypes = {
  sortData: PropTypes.object,
  onSortChange: PropTypes.func.isRequired,
};

Sort.defaultProps = {
  sortData: {},
};

export default Sort;



// WEBPACK FOOTER //
// ./src/client/components/common/Sort.js